import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Warehouse } from '@domain/inventory/models/Warehouse';

interface WarehouseSelectionProps {
  warehouses: Warehouse[];
  selectedWarehouseId: string;
  onWarehouseChange: (warehouseId: string) => void;
}

export const WarehouseSelection: React.FC<WarehouseSelectionProps> = ({ 
  warehouses, 
  selectedWarehouseId, 
  onWarehouseChange 
}) => {
  return (
    <Box>
      <Typography variant="subtitle2" mb={2}>Destination Warehouse</Typography>
      <Box display="flex" flexDirection="row" alignItems="center" gap={2} flexWrap="wrap">
        {warehouses?.map((warehouse) => (
          <Button
            sx={{
              p: 2,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              maxWidth: 200,
              textAlign: 'left',
              justifyContent: 'flex-start',
            }}
            color={selectedWarehouseId === warehouse.id ? 'primary' : 'secondary'}
            variant="outlined"
            key={warehouse.id}
            onClick={() => onWarehouseChange(warehouse.id)}
          >
            {warehouse.name}
          </Button>
        ))}
      </Box>
    </Box>
  );
}; 